import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '@store/store.ts'
import { hydrateCategoriesFromJSON, hydrateCompleteTimelineFromDOMNode, hydrateCurrentUser } from '@utils/hydrator.js'
import SuspenseFallback from '@components/SuspenseFallback.tsx'

import { AbilityContext } from './can.js'
import defineAbilityFor from './ability.js'
import { getCurrentUser } from '@selectors/data/user_selectors.js'

const ClassicTimelineEditorContainer = lazy(() =>
  import('@features/classic_timeline_editor/index.js').then(module => {
    return {
      default: module.ClassicTimelineEditorContainer,
    }
  })
)

window.Timetoast.timelines = {
  ...window.Timetoast.timelines,
  edit: {
    init: function (options) {
      const { timelineId, categoriesData } = options.data.raw
      const { editableTimeline } = options.data.dom

      // hydrate
      hydrateCurrentUser()
      hydrateCategoriesFromJSON(categoriesData)
      hydrateCompleteTimelineFromDOMNode(editableTimeline)

      const currentUser = getCurrentUser(store.getState())
      const ability = defineAbilityFor(currentUser)

      // editor with edit actions
      const editorRoot = createRoot(document.getElementById(options.targets.editor))
      editorRoot.render(
        <Provider store={store}>
          <AbilityContext.Provider value={ability}>
            <Suspense fallback={<SuspenseFallback />}>
              <ClassicTimelineEditorContainer timelineId={timelineId} />
            </Suspense>
          </AbilityContext.Provider>
        </Provider>
      )
    },
  },
}
